module.exports = __webpack_public_path__ + "static/media/call_landline.07e7afe7.svg";